import _styled from "styled-components";
import * as React from 'react';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import ReactHTMLParser from 'react-html-parser';
import { Flex } from '@latitude/box';
import { ANALYTICS, BREAKPOINT, BUTTON_STYLE, MARGIN } from '@latitude/core/utils/constants';
import { HeroContainer, HeroContent, HeroContentInner, HeroFootnote, HeroImage, HeroInner, HeroLink, HeroText, HeroTitle } from './Hero.styles';
import HeroFastApply from './HeroFastApply';
import HeroOr from './HeroOr';
import HeroCallUs from './HeroCallUs';
const Hero = _ref => {
  let {
    backgroundColor,
    buttonProps,
    className,
    children,
    fastApply,
    footnote,
    imageContent,
    orCallUs,
    title,
    text,
    transparentBg,
    simple
  } = _ref;
  return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
    location: ANALYTICS.LOCATION.HERO
  }, /*#__PURE__*/React.createElement(HeroContainer, {
    backgroundColor: backgroundColor,
    className: className
  }, /*#__PURE__*/React.createElement(HeroInner, null, !simple && /*#__PURE__*/React.createElement(HeroImage, null, imageContent), /*#__PURE__*/React.createElement(HeroContent, {
    simple: simple,
    className: "HeroContent",
    transparentBg: transparentBg
  }, children, !children && /*#__PURE__*/React.createElement(HeroContentInner, {
    isResponsive: true
  }, title && /*#__PURE__*/React.createElement(HeroTitle, null, ReactHTMLParser(title)), text && /*#__PURE__*/React.createElement(HeroText, null, ReactHTMLParser(text)), buttonProps && /*#__PURE__*/React.createElement(_StyledFlex, {
    $_css: MARGIN.M24,
    $_css2: BREAKPOINT.LG,
    $_css3: MARGIN.M32,
    $_css4: MARGIN.M24,
    $_css5: BREAKPOINT.LG,
    $_css6: MARGIN.M32
  }, /*#__PURE__*/React.createElement(HeroLink, Object.assign({
    button: BUTTON_STYLE.PRIMARY
  }, buttonProps)), fastApply && /*#__PURE__*/React.createElement(HeroFastApply, null), orCallUs && /*#__PURE__*/React.createElement(HeroOr, null), orCallUs && /*#__PURE__*/React.createElement(HeroCallUs, {
    orCallUs: orCallUs
  })), footnote && /*#__PURE__*/React.createElement(HeroFootnote, null, footnote))))));
};
export default Hero;
var _StyledFlex = /*#__PURE__*/_styled(Flex).withConfig({
  displayName: "Hero___StyledFlex",
  componentId: "sc-18mhm29-0"
})(["flex-wrap:wrap;margin-top:-", ";@media (min-width:", "){margin-top:-", ";}> *{margin-top:", ";@media (min-width:", "){margin-top:", ";}}"], p => p.$_css, p => p.$_css2, p => p.$_css3, p => p.$_css4, p => p.$_css5, p => p.$_css6);